import type { WP_REST_API_Menu_Item } from 'wp-types';

export interface WpMenuItem extends WP_REST_API_Menu_Item {
  children: WpMenuItem[];
  has_children: boolean;
}

export default (fetch: typeof $fetch) => ({
  getBySlug: async (slug: string) => {
    const response = await fetch<WpMenuItem[]>('/rys/v1/menu-items', {
      query: { slug }
    });

    return response
      .map((menuItem) => {
        menuItem.children = response
          .filter((item) => item.menu_item_parent === `${menuItem.ID}`)
          .sort((a, b) => a.menu_order - b.menu_order);

        menuItem.has_children = menuItem.children.length > 0;

        return menuItem;
      })
      .filter((item) => item.menu_item_parent === '0')
      .sort((a, b) => a.menu_order - b.menu_order);
  }
});
